import React, { Component } from "react";
import Step1 from "./Forms/Step1";
import Step2 from "./Forms/Step2";
import Step3 from "./Forms/Step3";
import Step4 from "./Forms/Step4";
import Step5 from "./Forms/Step5";
import { Button, Form } from "reactstrap";
import {
  nannyGenerateOtp,
  nannyStep1,
  nannyStep2,
  nannyStep3,
  nannyStep4,
  nannyVerifyOtp,
} from "../../Services/allServices";
import { Helmet } from "react-helmet";

function normalizeGooglePlace(details, description) {
  var comps = (details && details.address_components) || [];

  var raw = {};
  comps.forEach(function(c) {
    if (c.types.indexOf("subpremise") !== -1) raw.subpremise = c.long_name;
    if (c.types.indexOf("premise") !== -1) raw.premise = c.long_name;
    if (c.types.indexOf("street_number") !== -1) raw.streetNumber = c.long_name;
    if (c.types.indexOf("route") !== -1) raw.route = c.long_name;
    if (c.types.indexOf("neighborhood") !== -1) raw.neighborhood = c.long_name;
    if (c.types.indexOf("sublocality_level_3") !== -1) raw.sublocality3 = c.long_name;
    if (c.types.indexOf("sublocality_level_2") !== -1) raw.sublocality2 = c.long_name;
    if (c.types.indexOf("sublocality_level_1") !== -1) raw.sublocality1 = c.long_name;
    if (c.types.indexOf("locality") !== -1) raw.locality = c.long_name;
    if (c.types.indexOf("administrative_area_level_3") !== -1) raw.admin3 = c.long_name;
    if (c.types.indexOf("administrative_area_level_2") !== -1) raw.admin2 = c.long_name;
    if (c.types.indexOf("administrative_area_level_1") !== -1) raw.admin1 = c.long_name;
    if (c.types.indexOf("country") !== -1) raw.country = c.long_name;
    if (c.types.indexOf("postal_code") !== -1) raw.pincode = c.long_name;
  });

  var address =
    [raw.premise, raw.subpremise].filter(Boolean).join(", ") ||
    [raw.streetNumber, raw.route].filter(Boolean).join(" ") ||
    "";
  var city = raw.locality || raw.admin3 || raw.admin2 || "";
  var area =
    raw.neighborhood ||
    raw.sublocality3 ||
    raw.sublocality2 ||
    raw.sublocality1 ||
    city ||
    "";
  var district = raw.admin3 || raw.admin2 || "";
  var state = raw.admin1 || "";
  var country = raw.country || "";
  var pincode = raw.pincode || "";

  var geometryLocation = details && details.geometry && details.geometry.location;
  var lat = geometryLocation
    ? typeof geometryLocation.lat === "function"
      ? geometryLocation.lat()
      : geometryLocation.lat
    : null;
  var lng = geometryLocation
    ? typeof geometryLocation.lng === "function"
      ? geometryLocation.lng()
      : geometryLocation.lng
    : null;

  return {
    fullAddress: description || (details && details.formatted_address) || null,
    address: address,
    area: area,
    city: city,
    district: district,
    state: state,
    country: country,
    pincode: pincode,
    latitude: lat,
    longitude: lng,
    _raw: raw,
  };
}

function buildGoogleLocation(placeResult, addressType, description) {
  if (!addressType) addressType = "currentAddress";
  if (!placeResult || !placeResult.geometry) return null;

  var normalized = normalizeGooglePlace(placeResult, description);
  var latitude = Number(normalized.latitude);
  var longitude = Number(normalized.longitude);

  return {
    city: normalized.city,
    region: normalized.state,
    country: normalized.country,
    pincode: normalized.pincode ? Number(normalized.pincode) : null,
    latitude: Number.isFinite(latitude) ? latitude : null,
    longitude: Number.isFinite(longitude) ? longitude : null,
    fullAddress:
      normalized.fullAddress ||
      (placeResult && placeResult.formatted_address) ||
      null,
    address: normalized.address,
    area: normalized.area,
  };
}

export default class Nanny extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentStep: 1,
      isOtpSend: false,
      otp: "",
      mobile: "",
      name: "",
      location: "",
      googleLocation: null,
      gender: "",
      isForSelf: "",
      selectedService: [],
      selectedHours: [],
      selectedExperience: "",
      errors: {
        isOtpValid: false,
      },
      countDownTime: 59,
      secondsLeft: 59,
      isResendOtp: false,
      isDisabled: false,
    };
  }

  handleResetClick = () => {
    // this.resentOtp();
    this.setState({
      secondsLeft: this.state.countDownTime,
      isResendOtp: true,
    });
    clearInterval(this.incrementer);
    this.incrementer = setInterval(() => {
      this.setState({
        secondsLeft: this.state.secondsLeft - 1,
      });
      if (this.state.secondsLeft === 0) {
        clearInterval(this.incrementer);
      }
    }, 1000);
    this.setState({
      incrementer: this.incrementer,
    });
  };

  componentDidUpdate(props, prevState) {
    if (this.state.secondsLeft == 0 && prevState.secondsLeft == 1)
      this.setState({ isResendOtp: false });
  }

  handlePlaceChanged = () => {
    if (this.searchBoxInitialized) {
      return;
    }

    const input = document.getElementById("pac-input");
    if (!input || !window.google || !window.google.maps || !window.google.maps.places) {
      return;
    }

    this.searchBoxInitialized = true;
    this.searchBox = new window.google.maps.places.SearchBox(input);

    this.searchBox.addListener("places_changed", () => {
      const places = this.searchBox.getPlaces();
      const place = places && places.length > 0 ? places[0] : null;

      if (!place) {
        this.setState({
          location: input.value,
          googleLocation: null,
        });
        return;
      }

      const googleLocation = buildGoogleLocation(place, "currentAddress", input.value);

      this.setState({
        location: input.value,
        googleLocation,
      });
    });
  };

  handleLocationInputChange = (event) => {
    const value = event && event.target ? event.target.value : "";
    this.setState({
      location: value,
      // Free-text typing means no verified autocomplete place was chosen.
      googleLocation: null,
    });
  };

  gotoMomKidCare = () => {
    window.location.href = "https://www.momkidcare.com/";
  };

  handleChange = (event) => {
    const { name, value, checked } = event.target;
    console.log("this.state.erros", this.state.selectedHours);
    this.setState({
      [name]: value,
    });

    // 🔥 Special logic for gender
    if (name === "gender") {
      if (value === "1") {
        // Male selected → default Yes
        this.setState({ isForSelf: "1" });
      } else {
        // Female selected → clear isForSelf
        this.setState({ isForSelf: "" });
      }
    }

    // Case 1 : The user checks the box
    if (checked) {
      if (name == "selectedService") {
        this.setState({
          selectedService: [...this.state.selectedService, value],
        });
      } else if (name == "selectedHours") {
        this.setState({
          selectedHours: [...this.state.selectedHours, value],
        });
      }
    }

    // Case 2  : The user unchecks the box
    else {
      if (name == "selectedService") {
        this.setState({
          selectedService: this.state.selectedService.filter(
            (e) => e !== value
          ),
        });
      } else if (name == "selectedHours") {
        this.setState({
          selectedHours: this.state.selectedHours.filter((e) => e !== value),
        });
      }
    }
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    this.setState({isDisabled:true});
    const { mobile, selectedExperience, selectedHours, googleLocation } = this.state;
    let errors = this.validate();
    const data = this.isValid(errors);
    if (!data) {
      let s1 = { ...this.state };
      s1.errors = errors;
      this.setState(s1);
    } else {
      const response = await nannyStep4({
        selectedHours,
        selectedExperience,
        mobile,
        googleLocation,
        experience: selectedExperience || null,
        age: null,
        dob: null,
      });
      this.setState({
        currentStep: 5,
        errors: {},
      });
    }
  };

  sendOtp = async (e) => {
    e.preventDefault();
    let errors = this.validate();
    const data = this.isValid(errors);
    if (!data) {
      let e = { ...this.state };
      e.errors = errors;
      this.setState(e);
    } else {
      const data = {
        mobile: this.state.mobile,
      };
      const response = await nannyGenerateOtp(data);
      if (response.data.error) {
        this.setState({
          isOtpSend: false,
          errors: { mobile: response.data.message },
        });
      } else {
        this.handleResetClick();
        this.setState({
          isOtpSend: true,
          errors: { mobile: "" },
          isResendOtp: true,
        });
      }
    }
  };

  verifyOtp = async (e) => {
    e.preventDefault();
    const urlParams = new URLSearchParams(window.location.hash.split('?')[1]);
    function getUTMSource() {
      const utmSource = localStorage.getItem('utm_source');
      return utmSource;
    }
    const utmSource = getUTMSource();
    const { mobile, otp } = this.state;
    const response = await nannyVerifyOtp({ mobile, otp,utmSource });
    console.log(response);
    if (response.data.error) {
      this.setState({ errors: { isOtpValid: true } });
    } else {
      const res = await nannyStep1({ mobile });
      this.setState({
        currentStep: 2,
        errors: { isOtpValid: true },
      });
    }
  };

  resentOtp = async () => {
    const { mobile } = this.state;
    this.handleResetClick();
    const response = await nannyGenerateOtp({ mobile });
    console.log(response);
    if (response.data.error) {
      this.setState({
        errors: { isOtpValid: false, mobile: response.data.message },
      });
    } else {
      this.setState({
        // currentStep: 2,
        errors: { isOtpValid: false },
      });
    }
  };

  //validate inputs fields

  validate = () => {
    let errors = {};
    const mobileExp = /^[6-9]\d{9}$/;
    const {
      currentStep,
      mobile,
      name,
      location,
      gender,
      selectedExperience,
      selectedHours,
      selectedService,
    } = this.state;

    if (currentStep == 1 && !mobileExp.test(mobile)) {
      errors.mobile = "कृपया मान्य मोबाइल नंबर दर्ज करें।";
    }
    if (currentStep == 2 && !name) {
      errors.name = "नाम भरना आवश्यक है।";
    }
    if (currentStep == 2 && !location) {
      errors.location = "कृपया अपना स्थान चुने।";
    }
    if (currentStep == 2 && !gender) {
      errors.gender = "लिंग का चयन आवश्यक है।";
    }

    if (currentStep == 3 && selectedService.length==0) {
      errors.selectedService = "कृपया कम से कम एक सेवा का चयन करें।";
    }

    if (currentStep == 4 && selectedHours.length == 0) {
      errors.selectedHours = "कृपया कार्य का समय चुनें।";
    }
    if (currentStep == 4 && !selectedExperience) {
      errors.selectedExperience = "कृपया अपने कार्य अनुभव का चयन करें।";
    }

    return errors;
  };

  handleResetClick(event) {
    this.setState({
      secondsLeft: this.state.countDownTime,
    });
    clearInterval(this.incrementer);
    this.incrementer = setInterval(() => {
      this.setState({
        secondsLeft: this.state.secondsLeft - 1,
      });
      if (this.state.secondsLeft === 0) {
        clearInterval(this.incrementer);
      }
    }, 1000);
    this.setState({
      incrementer: this.incrementer,
    });
  }

  isValid = (errors) => {
    let key = Object.keys(errors);
    let count = key.reduce((acc, cur) => (errors[cur] ? acc + 1 : acc), 0);
    return count == 0;
  };

  _next = async (e) => {
    e.preventDefault();
    const { currentStep, mobile, name, location, gender, isForSelf, selectedService } =
      this.state;
    if (currentStep == 2) {
      const response = await nannyStep2({ mobile, name, location, gender, isForSelf });
    }
    if (currentStep == 3) {
      const response = await nannyStep3({ mobile, selectedService });
    }

    let errors = this.validate();
    const data = this.isValid(errors);
    if (!data) {
      let e = { ...this.state };
      e.errors = errors;
      this.setState(e);
    } else {
      let currentStep = this.state.currentStep;
      currentStep = currentStep >= 4 ? 5 : currentStep + 1;
      this.setState({
        currentStep: currentStep,
        errors: {
          isOtpValid: false,
        },
      });
    }
  };

  _prev = () => {
    let currentStep = this.state.currentStep;
    currentStep = currentStep <= 1 ? 1 : currentStep - 1;
    this.setState({
      currentStep: currentStep,
      errors: {
        isOtpValid: false,
      },
    });
  };

  previousButton() {
    let currentStep = this.state.currentStep;
    if (currentStep !== 1) {
      return (
        <button
          className="btn btn-link btn-sm ml-0 pl-0"
          type="button"
          style={{
            color: "#00A2FF",
            border: 0,
            outline: 0,
            boxShadow: "none",
            textDecoration: "none",
          }}
          onClick={this._prev}
        >
          Back
        </button>
      );
    }
    return null;
  }

  nextButton() {
    let currentStep = this.state.currentStep;
    if (currentStep < 4) {
      return (
        <Button
          className="float-left px-4 py-2"
          style={{
            backgroundColor: "#00A2FF",
            border: 0,
            fontSize: "12px",
            color: "#fff",
          }}
          type="submit"
          onClick={this._next}
        >
          Next
        </Button>
      );
    }
    return null;
  }

  render() {
    return (
      <>
        <Helmet>
          <body style="background-color: #fff"></body>
          <title>Japa | Nanny Job Application</title>

        </Helmet>
        <div className="nanny">
          <Step1
            currentStep={this.state.currentStep}
            handleChange={this.handleChange}
            next={this.nextButton()}
            sendOtp={this.sendOtp}
            verifyOtp={this.verifyOtp}
            isOtpSend={this.state.isOtpSend}
            errors={this.state.errors}
            resentOtp={this.resentOtp}
            mobile={this.state.mobile}
            secondsLeft={this.state.secondsLeft}
            handleResetClick={this.handleResetClick}
            isResendOtp={this.state.isResendOtp}
            gotoMomKidCare={this.gotoMomKidCare}
            />
          <Step2
            currentStep={this.state.currentStep}
            handleChange={this.handleChange}
            handleLocationInputChange={this.handleLocationInputChange}
            next={this.nextButton()}
            prev={this.previousButton()}
            location={this.state.location}
            gotoMomKidCare={this.gotoMomKidCare}
            handlePlaceChanged={this.handlePlaceChanged}
            errors={this.state.errors}
            gender={this.state.gender}
            isForSelf={this.state.isForSelf}
            name={this.state.name}
            _next={this._next}
          />
          <Step3
            currentStep={this.state.currentStep}
            handleChange={this.handleChange}
            next={this.nextButton()}
            prev={this.previousButton()}
            gotoMomKidCare={this.gotoMomKidCare}
            errors={this.state.errors}
            selectedService={this.state.selectedService}
            _next={this._next}
          />
          <Step4
            currentStep={this.state.currentStep}
            handleChange={this.handleChange}
            handleSubmit={this.handleSubmit}
            prev={this.previousButton()}
            gotoMomKidCare={this.gotoMomKidCare}
            errors={this.state.errors}
            selectedHours={this.state.selectedHours}
            selectedExperience={this.state.selectedExperience}
            isDisabled={this.state.isDisabled}
          />
          <Step5
            currentStep={this.state.currentStep}
            gotoMomKidCare={this.gotoMomKidCare}
          ></Step5>
        </div>
      </>
    );
  }
}
